import dynamic from 'next/dynamic';

import LazyHydration from 'components/LazyHydration';

const RelatedOffers = dynamic(() => import('./RelatedOffers'), { ssr: false });

const DynamicallyLoadedRelatedOffers = (props) => (
  <LazyHydration placeholderSize={{ height: 470 }}>
    <RelatedOffers {...props} />
  </LazyHydration>
);

export default DynamicallyLoadedRelatedOffers;
